import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import TransactionStockServices from '../../../services/axiosServices/apiServices/TransactionStockServices';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import moment from 'moment';
import CommonServices from '../../../services/axiosServices/apiServices/CommonServices';
import { saveAs } from "file-saver";
import { SelectItemListPopUp } from '../../../components/dropdown/SelectItemListPopUp';
import { MaterialTestingPopup } from './MaterialTestingTable';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class MaterialTesting extends Component {

    constructor(props) {
        super(props)
        this.transactionStockServices = new TransactionStockServices();
        this.accountTransactionServices = new AccountTransactionServices();
        this.SwalServices = new SwalServices();
        this.commonServices = new CommonServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            isSaving: false,
            isTable2Expanded: false,
            itemRowData: [],
            selectedRowsFromItemRows: [],
            open: false,
            rowData: [],
            colDefs: [],
            materialRowData: [],
            materialColdefs: [],
            paginationPageSize: 50,
            isSelectItemPopUp: false,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            materialObject: {
                testingNo: '',
                testingDate: '',
                materialList: [],
                idMaterialInward: 0,
                inspectList: [],
                idInspectedBy: 0,
                vendorList: [],
                idPartyAccount: 0,
                updateStatus: 0,
                idMaterialTesting: 0,
                inwardDate: '',
                inwardNo: '',
                heatNo: '',
                approvedList: [],
                idApprovedBy: 0,
                remarks: '',
                totalPurchaseQuantity: '',
                totalPassQuantity: '',
                totalRejectQty: '',
            },
            extraObject: {
                drawingNo: '',
                itemType: '',
                itemDetails: '',
                inwardQty: '',
                rejectQty: '',
                reworkQty: '',
                passQty: '',
                status: '',
                tc: '',
                attachment: '',
                remarks: '',
                idMaterialInwardItems: 0,
                idMaterialInward: 0,
                idMaterialPlanning: 0,
                idMaterialPlanningDetails: 0,
                idPurchaseOrder: 0,
                idPurchaseOrderItems: 0,
                statusList: [
                    { value: 1, label: 'PASS' },
                    { value: 2, label: 'REJECT' },
                ],
                tcList: [
                    { value: 1, label: 'YES' },
                    { value: 2, label: 'NO' },
                ],
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRulesForWork: {
                invoiceDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "invoice date"
                        ),
                    },
                ],
                idCustomer: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "customer"
                        ),
                    },
                ],
                idAccHead: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "account head"
                        ),
                    },
                ],
            },
            validationRules: {
                testingDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "date"
                        ),
                    },
                ],
                idPartyAccount: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "vendor"
                        ),
                    },
                ],
                idMaterialInward: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "material"
                        ),
                    },
                ],
            },
        }
    }

    componentDidMount = () => {
        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser ? prop.idUser : 0 }, () => {
                this.procSelectAllRecordsSP();
                this.getVendorListFromMaterialPurchase()
                // this.usp_Master_PartyAccountSelect();
            }, () => {
                if (this.gridApi) {
                    this.gridApi.hideOverlay();
                }
            });
        }
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Material Testing",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: this.state.idUser,
            //idFinancialYear : null,
            //idPlant : 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        //debugger;
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key),
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            width: this.getPinnedWidth(key),
                            hide: ["idMaterialTesting", "idPartyAccount"].includes(key),
                            pinned: ["sR.No", "inwardNo", "gatePassNo", "inwardDate", "vendor"].includes(key) ? "left" : null,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.includes("testingDate") || key.includes("inwardDate")
                                ? (params) => {
                                    if (!params.value) return "";
                                    return moment(params.value).format("DD-MM-YYYY");
                                }
                                : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Material Purchase",
                            colName: colName
                        }, () => {
                            this.setPermissions(permissions)
                            this.procSelectAllRecord2GridviewSP(id);
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            } else {
                if (this.gridApi) {
                    this.gridApi.hideOverlay();
                    this.gridApi.showNoRowsOverlay();
                }
                //this.getPrefixSelectPrefix();
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "invoiceNo": window.innerWidth * 0.07,
            "invoiceDate": window.innerWidth * 0.08,
            "totalQty": window.innerWidth * 0.05,
            "totalAmt": window.innerWidth * 0.06,
            "extraCharges": window.innerWidth * 0.05,
            "discount": window.innerWidth * 0.05,
            "taxAmt": window.innerWidth * 0.06,
            "finalAmt": window.innerWidth * 0.05,
            "poNo": window.innerWidth * 0.05,
            "isApprove": window.innerWidth * 0.06,
            "approvalStatus": window.innerWidth * 0.08,
            "debitStatus": window.innerWidth * 0.08,
            "diffAmount": window.innerWidth * 0.06,
            "qcStatus": window.innerWidth * 0.08,
        }
        return colwidth[key]
    }

    getPinnedWidth = (key) => {
        const pinnedWidths = {
            "sR.No": window.innerWidth * 0.05,
            "inwardNo": window.innerWidth * 0.06,
            "gatePassNo": window.innerWidth * 0.06,
            "inwardDate": window.innerWidth * 0.08,
            "vendor": window.innerWidth * 0.15,
        }
        return pinnedWidths[key];
    }

    procSelectAllRecord2GridviewSP = (id) => {
        //debugger;
        let request = {
            id: id,
            formname: "Material Testing",
            allowToRateVisible: 1,
            //idCompany: this.state.prop.idCompany
        }
        //debugger
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                //debugger
                if (response.statusCode == 200 && response.responseItem !== null) {
                    //debugger;
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            flex: 1,
                            minWidth: this.table2ColWidth(key),
                            pinned: this.table2PinnedWidth(key) ? "left" : null,
                            width: this.table2ColWidth(key),
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    } else {
                        this.setState({
                            table2Data: [],
                            table2ColDefs: [],
                            isTable2Expanded: false
                        });
                    }
                }
            });
        }
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    getVendorListFromMaterialPurchase = () => {
        let request = {
            idCompany: this.state.idCompany,
            updateStatus: this.state.materialObject.updateStatus,
            idMaterialInward: this.state.materialObject.idMaterialInward,
        };
        this.transactionStockServices.usp_Transaction_PurchaseInwardSelectIDVendorNotInMaterialTesting(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    dynamicData = dynamicData.map((x) => ({
                        value: x.idPartyAccount,
                        label: x.partyACName,
                    })).filter((item, index, self) =>
                        index === self.findIndex((t) => t.value === item.value)
                    );;
                    let object = this.state.materialObject;
                    object.vendorList = dynamicData;
                    this.setState({ materialObject: object }, () => {
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                        }
                    });
                } else {
                    let object = this.state.materialObject;
                    object.vendorList = [];
                    this.setState({ materialObject: object })
                }
            }
        });
    }

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.setState({ open: false });
        this.transactionStockServices.getInvoiceCountForMaterialTesting(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let total = response.responseItem.responseContent[0].totalCount + 1

                let formatted = '';
                if (total.toString().length === 1) {
                    formatted = '00' + total;
                } else if (total.toString().length === 2) {
                    formatted = '0' + total;
                } else {
                    formatted = total.toString();
                }
                let materialObject = this.state.materialObject
                materialObject.testingNo = formatted
                materialObject.testingDate = moment(new Date()).format('YYYY-MM-DD');
                this.setState({ materialObject: materialObject }, () => {

                    this.setState({ isModalOpen: true }, () => {
                        this.resetDetailsFields();
                        this.setState({ itemRowData: [] })
                    })
                })
            }
        });
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.setState({ open: false })
        this.getTransactionMaterialTestingSelectbyId(event.data.idMaterialTesting);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    handleCellClick = (event) => {
        this.procSelectAllRecord2GridviewSP(event.data.idMaterialTesting);
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    isValidAllFieldsForWork = () => {
        const newValidState = isValidForm(
            this.state.purchaseObject,
            this.state.validationRulesForWork,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.materialObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleChangeForWork = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.purchaseObject;
        if (name === "isClose") {
            details.isClose = !details.isClose;
        } else {
            details[name] = value;
        }
        this.setState({ purchaseObject: details }, () => {
            if (name === 'tcsPercentage') {
                this.finalCalculation();
            }
        });
    }

    handleChange = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.materialObject;
        details[name] = value;
        this.setState({ materialObject: details });
    }
    handleChangeExtra = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.extraObject;
        details[name] = value;
        this.setState({ extraObject: details });
    }

    resetDetailsFields = () => {
        let materialObject = this.state.materialObject;
        materialObject.idMaterialInward = 0
        materialObject.idInspectedBy = 0
        materialObject.idPartyAccount = 0
        materialObject.inwardDate = ''
        materialObject.heatNo = ''
        materialObject.idApprovedBy = 0
        materialObject.remarks = ''
        materialObject.totalPurchaseQuantity = ''
        materialObject.totalPassQuantity = ''
        materialObject.totalRejectQty = ''
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState,
            materialObject: materialObject,
        }, () => {
            this.getVendorListFromMaterialPurchase()
            this.usp_Transaction_PurchaseInwardSelectbyIDVendorNotInMaterialTesting()
        });
    }

    handleChangeForDropdown = (event, name) => {
        let details = this.state.materialObject;
        let value = event.value;
        details[name] = value;
        if (name === 'idMaterialInward') {
            details.inwardDate = event.inwardDate ? moment(event.inwardDate).format('YYYY-MM-DD') : '';
            details.inwardNo = event.label;
        }
        this.setState({ materialObject: details }, () => {
            if (name === 'idPartyAccount') {
                this.usp_Transaction_PurchaseInwardSelectbyIDVendorNotInMaterialTesting()
            }
            if (name === 'idMaterialInward') {
                this.usp_Transaction_PurchaseInwardSelectbyId(event.value)
            }
        });
    }

    handleChangeForDropdownForExtraObject = (event, name) => {
        let details = this.state.extraObject;
        let label = event.label;
        details[name] = label;
        this.setState({ extraObject: details });
    }

    onItemRowDataClicked = (event) => {
        const itemRowData = [...this.state.itemRowData];
        const clickedId = event.data.idMaterialInwardItems;

        const getItemData = itemRowData.find(item => item.idMaterialInwardItems === clickedId);
        if (!getItemData) return;

        const details = { ...this.state.extraObject };
        details.drawingNo = getItemData.drawingNo;
        details.itemType = getItemData.materialType;
        details.itemDetails = getItemData.itemName;
        details.inwardQty = getItemData.inwardQuantity;
        details.rejectQty = getItemData.rejectQuantity;
        details.reworkQty = getItemData.reworkQuantity;
        details.passQty = getItemData.passQuantity;
        details.remarks = getItemData.remarks;
        details.idMaterialInwardItems = getItemData.idMaterialInwardItems;
        details.idMaterialInward = getItemData.idMaterialInward;
        details.idMaterialPlanning = getItemData.idMaterialPlanning;
        details.idMaterialPlanningDetails = getItemData.idMaterialPlanningDetails;
        details.idPurchaseOrder = getItemData.idPurchaseOrder;
        details.idPurchaseOrderItems = getItemData.idPurchaseOrderItems;
        details.keyId = getItemData.keyId;
        details.tc = getItemData.tc ? getItemData.tc : 'NO';
        details.status = getItemData.status ? getItemData.status : '';
        details.attachment = getItemData.attachment ? getItemData.attachment : "";

        this.setState({ extraObject: details });
    };

    handleDeleteItem = (keyId) => {
        let data = this.state.itemRowData.filter((x) => x.idPurchaseOrderItems != keyId);
        this.setState({ itemRowData: data }, () => {
            this.SwalServices.Success("Deleted sucessfully.");
            this.finalCalculation();
            this.resetProductObject();
        });
    };

    table2ColWidth = (key) => {
        const colWidth = {
            // "poNo": window.innerWidth * 0.05,
            // "drawingNo": window.innerWidth * 0.1,
            // "itemCategory": window.innerWidth * 0.15,
            // "itemName": window.innerWidth * 0.15,
            // "inwardQuantity": window.innerWidth * 0.06,
            // "rate": window.innerWidth * 0.06,
            // "taxableAmt": window.innerWidth * 0.06,
            // "sgst": window.innerWidth * 0.05,
            // "sgstAmt": window.innerWidth * 0.06,
            // "cgst": window.innerWidth * 0.05,
            // "cgstAmt": window.innerWidth * 0.06,
            // "igst": window.innerWidth * 0.05,
            // "igstAmt": window.innerWidth * 0.06,
            // "netTotal": window.innerWidth * 0.08,
        }
        return colWidth[key];
    }

    table2PinnedWidth = (key) => {
        const pinnedWidths = {
            // "productName": window.innerWidth * 0.1,
            // "inwardQuantity": window.innerWidth * 0.1,
            // "rate": window.innerWidth * 0.08,
            // "taxableAmt": window.innerWidth * 0.08,
        }
        return pinnedWidths[key];
    }

    usp_Master_PartyAccountSelect = () => {
        this.accountTransactionServices.usp_Master_PartyAccountSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    dynamicData = dynamicData.map((x) => ({
                        value: x.idPartyAccount,
                        label: x.partyACName,
                        partyAddress: x.p_Address
                    }));
                    let object = this.state.materialObject;
                    object.vendorList = dynamicData;
                    this.setState({ materialObject: object }, () => {
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                        }
                    });
                } else {
                    let object = this.state.materialObject;
                    object.vendorList = [];
                    this.setState({ materialObject: object })
                }
            }
        });
    }

    usp_Transaction_PurchaseInwardSelectbyIDVendorNotInMaterialTesting = () => {
        if (this.state.materialObject.idPartyAccount > 0) {
            let request = {
                idVendor: this.state.materialObject.idPartyAccount,
                idCompany: this.state.idCompany,
                updateStatus: this.state.materialObject.updateStatus,
                idMaterialTesting: this.state.materialObject.idMaterialTesting,
            };
            this.transactionStockServices.usp_Transaction_PurchaseInwardSelectbyIDVendorNotInMaterialTesting(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        dynamicData = dynamicData.map((x) => ({
                            value: x.idMaterialInward,
                            label: x.inwardNo ? x.inwardNo : '',
                            inwardDate: x.inwardDate
                        }));
                        let object = this.state.materialObject;
                        object.materialList = dynamicData;
                        this.setState({ materialObject: object });
                    }
                }
            });
        } else {
            let object = this.state.materialObject;
            object.materialList = [];
            this.setState({ materialObject: object });
        }
    }

    usp_Transaction_PurchaseInwardSelectbyId = (idMaterialInward) => {
        if (idMaterialInward > 0) {
            this.transactionStockServices.getTransactionPurchaseInwardSelectbyId(idMaterialInward).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let itemListRecords = response.responseItem.responseContent[1];
                    let itemList = [];

                    itemListRecords.map((details, keyId) => {
                        let obj = {
                            drawingNo: details.itemDrawingNo,
                            inwardQuantity: details.inwardQuantity,
                            materialType: details.itemItemType,
                            idItem: details.idItem,
                            itemName: details.itemName,
                            idMaterialInward: details.idMaterialInward,
                            passQuantity: details.inwardQuantity,
                            tc: 'NO',
                            rejectQuantity: 0,
                            reworkQuantity: 0,
                            keyId: keyId + 1,
                            idMaterialInwardItems: details.idMaterialInwardItems,
                            idMaterialInward: details.idMaterialInward,
                            idMaterialPlanning: details.idMaterialPlanning,
                            idMaterialPlanningDetails: details.idMaterialPlanningDetails,
                            idPurchaseOrder: details.idPurchaseOrder,
                            idPurchaseOrderItems: details.idPurchaseOrderItems,

                        }

                        if (this.state.materialObject.updateStatus === 1) {

                        } else {
                            obj.idMaterialTestingProducts = 0;
                            obj.passQuantity = details.inwardQuantity;
                            obj.inwardQuantity = details.inwardQuantity;
                        }

                        itemList.push(obj);
                    })

                    this.setState({ itemRowData: itemList });
                }
            });
        }
    }

    finalCalculation = () => {
        let data = this.state.selectedRowsFromItemRows;
        let finalAmountCal = this.state.materialObject;
        finalAmountCal.totalPassQuantity = 0;
        finalAmountCal.totalPurchaseQuantity = 0;
        finalAmountCal.totalRejectQty = 0;
        data.map((x) => {
            finalAmountCal.totalPassQuantity = Number(finalAmountCal.totalPassQuantity) + Number(x.passQuantity);
            finalAmountCal.totalPurchaseQuantity = Number(finalAmountCal.totalPurchaseQuantity) + Number(x.inwardQuantity);
            finalAmountCal.totalRejectQty = Number(finalAmountCal.totalRejectQty) + Number(x.rejectQuantity);
        });

        finalAmountCal.totalPassQuantity = Number(finalAmountCal.totalPassQuantity);
        finalAmountCal.totalPurchaseQuantity = Number(finalAmountCal.totalPurchaseQuantity);
        finalAmountCal.totalRejectQty = Number(finalAmountCal.totalRejectQty);
        this.setState({ materialObject: finalAmountCal });
    }


    insertItem = (flag) => {
        const details = { ...this.state.extraObject };
        let itemList = [...this.state.itemRowData];

        let newId = details.idMaterialInwardItems || Date.now();

        const obj = {
            idMaterialInwardItems: newId,
            idMaterialInward: details.idMaterialInward,
            idMaterialPlanning: details.idMaterialPlanning,
            idMaterialPlanningDetails: details.idMaterialPlanningDetails,
            idPurchaseOrder: details.idPurchaseOrder,
            idPurchaseOrderItems: details.idPurchaseOrderItems,
            drawingNo: details.drawingNo,
            materialType: details.itemType,
            idItem: details.idItem,
            itemName: details.itemDetails,
            inwardQuantity: details.inwardQty ? Number(details.inwardQty) : 0,
            rejectQuantity: details.rejectQty ? Number(details.rejectQty) : 0,
            reworkQuantity: details.reworkQty ? Number(details.reworkQty) : 0,
            passQuantity: details.inwardQty && details.rejectQty ? (Number(details.inwardQty) - Number(details.rejectQty)) : 0,
            tc: details.tc,
            status: details.status,
            remarks: details.remarks,
            keyId: details.keyId || itemList.length + 1,
            attachment: details.attachment || "",
        };

        if (flag === 'Insert') {
            itemList.push(obj);
        } else if (flag === 'Update') {
            const index = itemList.findIndex(
                (x) => x.idMaterialInwardItems === details.idMaterialInwardItems
            );

            if (index !== -1) {
                itemList[index] = obj;
            } else {
                console.warn('Item not found for update.');
                return;
            }
        }

        this.setState({ itemRowData: itemList }, () => {
            this.resetProductObject();
            this.finalCalculation();
        });
    };



    resetProductObject = () => {
        let details = this.state.extraObject;
        details.drawingNo = '';
        details.itemType = '';
        details.itemDetails = '';
        details.inwardQty = '';
        details.rejectQty = '';
        details.reworkQty = '';
        details.passQty = '';
        details.status = '';
        details.tc = '';
        details.attachment = '';
        details.remarks = '';
        details.idMaterialInwardItems = 0;
        details.idMaterialInward = 0;
        details.idMaterialPlanning = 0;
        details.idMaterialPlanningDetails = 0;
        details.idPurchaseOrder = 0;
        details.idPurchaseOrderItems = 0;
        details.keyId = 0;
        this.setState({ extraObject: details })
    }

    submit = () => {
        // guard against double-submit (rapid double-click / impatient re-click while the save is in flight)
        if (this.isSubmitting) {
            return;
        }
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            if (this.state.itemRowData.length === 0) {
                this.SwalServices.Alert("Please add items details");
            } else {
                let data = this.state.materialObject
                let request = {
                    idMaterialTesting: data.idMaterialTesting,
                    updateStatus: data.updateStatus,
                    testingNo: data.testingNo,
                    testingDate: data.testingDate,
                    idMaterialInward: data.idMaterialInward,
                    idPartyAccount: data.idPartyAccount,
                    heatNo: data.heatNo,
                    inwardNo: data.inwardNo,
                    inwardDate: data.inwardDate && data.inwardDate !== 'Invalid date' ? data.inwardDate : null,
                    idInspectedBy: data.idInspectedBy,
                    idApprovedBy: data.idApprovedBy,
                    totalPurchaseQuantity: data.totalPurchaseQuantity,
                    totalPassQuantity: data.totalPassQuantity,
                    totalRejectQuantity: data.totalRejectQty,
                    remarks: data.remarks,
                    idCompany: this.state.idCompany,
                    e_Date: data.e_Date ? data.e_Date : new Date().toISOString(),
                    e_IDUser: data.updateStatus === 1 ? this.state.idUser : null,
                    isUpdated: data.updateStatus === 1 ? true : false,
                    updatedDate: data.updateStatus === 1 ? new Date().toISOString() : null,
                    u_IDUser: data.updateStatus === 1 ? this.state.idUser : null,
                    isDeleted: false,
                    deletedDate: null,
                    d_IDUser: null,
                    prefix: '',
                    IDFinancialYear: 0
                };
                request.materialTestingList = [];
                let materialTestingList = this.state.selectedRowsFromItemRows;
                materialTestingList.map((details) => {
                    let obj = {
                        drawingNo: details.drawingNo,
                        itemType: details.materialType,
                        idItem: details.idItem,
                        inwardQuantity: details.inwardQuantity ? Number(details.inwardQuantity) : 0,
                        extraQuantity: 0,
                        rejectQuantity: details.rejectQuantity ? Number(details.rejectQuantity) : 0,
                        reworkQuantity: 0,
                        passQuantity: details.passQuantity ? Number(details.passQuantity) : 0,
                        status: details.status ? details.status : '',
                        tc: details.tc ? details.tc : 'NO',
                        fileName: details.attachment ? details.attachment : '',
                        fileExtension: details.attachment ? details.attachment.split('.').pop() : '',
                        remarks: details.remarks ? details.remarks : '',
                        idPurchase: details.idMaterialInward ? details.idMaterialInward : 0,
                        idPurchaseProduct: details.idMaterialInwardItems ? details.idMaterialInwardItems : 0,
                        idCompany: this.state.idCompany,
                        idMaterialTestingProducts: details.idMaterialTestingProducts ? details.idMaterialTestingProducts : 0,
                        idMaterialPlanning: details.idMaterialPlanning ? details.idMaterialPlanning : 0,
                        idMaterialPlanningDetails: details.idMaterialPlanningDetails ? details.idMaterialPlanningDetails : 0,
                    }
                    request.materialTestingList.push(obj);
                });
                this.isSubmitting = true;
                this.setState({ isSaving: true });
                this.transactionStockServices.submitMaterialTestingInsertUpdate(request).then((response) => {
                    if (response.statusCode == 200 && response.responseItem !== null) {
                        let data = response.responseItem.responseContent;
                        if (data !== null) {
                            if (this.state.materialObject.updateStatus === 1) {
                                this.SwalServices.Success("Updated sucessfully.");
                            } else {
                                this.SwalServices.Success("Save sucessfully.");
                            }
                            if (this.state.urlId) {
                                this.setState({ route: '/ledger-report' });
                            } else {
                                this.setState({
                                    isModalOpen: false,
                                }, () => {
                                    this.resetFields();
                                    this.procSelectAllRecordsSP();
                                    this.getVendorListFromMaterialPurchase()
                                    this.usp_Transaction_PurchaseInwardSelectbyIDVendorNotInMaterialTesting()
                                });
                            }
                        }
                    }
                }).finally(() => {
                    this.isSubmitting = false;
                    this.setState({ isSaving: false });
                });
            }
        }
    }

    resetFields = () => {
        let data = this.state.materialObject;
        data.idMaterialTesting = 0;
        data.updateStatus = 0;
        data.testingNo = '';
        data.testingDate = moment(new Date().toISOString()).format('YYYY-MM-DD');
        data.idMaterialInward = 0;
        data.idInspectedBy = 0;
        data.idPartyAccount = 0;
        data.inwardDate = moment(new Date().toISOString()).format('YYYY-MM-DD');
        data.heatNo = '';
        data.idApprovedBy = 0;
        data.remarks = '';
        this.setState({ materialObject: data }, () => {
            this.resetProductObject();
        })
    }

    getTransactionMaterialTestingSelectbyId = (idMaterialTesting) => {
        if (idMaterialTesting > 0) {
            this.transactionStockServices.getTransactionMaterialTestingSelectbyId(idMaterialTesting).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let data = response.responseItem.responseContent[0][0];
                    let itemListRecords = response.responseItem.responseContent[1];
                    let itemList = [];
                    let materialObject = this.state.materialObject;
                    materialObject.idMaterialTesting = data.idMaterialTesting
                    materialObject.updateStatus = 1
                    materialObject.testingNo = data.testingNo
                    materialObject.testingDate = data.testingDate ? moment(data.testingDate).format('YYYY-MM-DD') : ''
                    materialObject.idMaterialInward = data.idMaterialInward
                    materialObject.idPartyAccount = data.idPartyAccount
                    materialObject.heatNo = data.heatNo
                    materialObject.inwardNo = data.inwardNo
                    materialObject.inwardDate = data.inwardDate ? moment(data.inwardDate).format('YYYY-MM-DD') : '';
                    materialObject.idInspectedBy = data.idInspectedBy
                    materialObject.idApprovedBy = data.idApprovedBy
                    materialObject.totalPurchaseQuantity = data.totalPurchaseQuantity
                    materialObject.totalPassQuantity = data.totalPassQuantity
                    materialObject.totalRejectQty = data.totalRejectQuantity
                    materialObject.remarks = data.remarks
                    materialObject.e_Date = data.e_Date
                    this.setState({ materialObject: materialObject }, () => {
                        this.usp_Transaction_PurchaseInwardSelectbyIDVendorNotInMaterialTesting();
                    });
                    itemListRecords.map((details, keyId) => {
                        let obj = {
                            drawingNo: details.drawingNo,
                            materialType: details.itemType,
                            idItem: details.idItem,
                            itemName: details.itemName,
                            inwardQuantity: details.inwardQuantity ? Number(details.inwardQuantity) : 0,
                            extraQuantity: 0,
                            rejectQuantity: details.rejectQuantity ? Number(details.rejectQuantity) : 0,
                            reworkQuantity: 0,
                            passQuantity: details.passQuantity ? Number(details.passQuantity) : 0,
                            status: details.status ? details.status : '',
                            tc: details.tc ? details.tc : 'NO',
                            attachment: details.fileName ? details.fileName : '',
                            fileExtension: details.fileName ? details.fileName.split('.').pop() : '',
                            remarks: details.remarks ? details.remarks : '',
                            idMaterialInward: details.idPurchase ? details.idPurchase : 0,
                            idMaterialInwardItems: details.idPurchaseProduct ? details.idPurchaseProduct : 0,
                            idCompany: this.state.idCompany,
                            idMaterialTestingProducts: details.idMaterialTestingProducts ? details.idMaterialTestingProducts : 0,
                            idMaterialPlanning: details.idMaterialPlanning ? details.idMaterialPlanning : 0,
                            idMaterialPlanningDetails: details.idMaterialPlanningDetails ? details.idMaterialPlanningDetails : 0,
                            keyId: keyId + 1,
                        }
                        itemList.push(obj);
                    })

                    this.setState({ itemRowData: itemList, isModalOpen: true }, () => {
                        this.getVendorListFromMaterialPurchase()
                    });
                }
            });
        }
    }

    handleCellClickfirstPIList = (event) => {
        this.USP_Transaction_PurchaseOrderSelectbyID_PendingQty(event.data.idPurchaseOrder);
    };

    handleCellClickSecondPIList = (event) => {
        this.getItemRateVendorwiseSelect3(event.data.idItem);
    };

    getTransaction_PurchaseOrderSelectbyIDVendor = () => {
        let request = [this.state.purchaseObject.idPartyAccount, this.state.idCompany, this.state.purchaseObject.updateStatus, this.state.purchaseObject.idMaterialInward];
        this.transactionStockServices.getTransaction_PurchaseOrderSelectbyIDVendor(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent;
                let data = this.state.firstPIList;
                let idPurchaseOrder = 0;
                data = [];
                if (res.length > 0) {
                    res.map((x) => {
                        x.Select = false;
                        x.deliveryDate = moment(x.deliveryDate).format("DD-MM-YYYY");
                        x.poDate = moment(x.poDate).format("DD-MM-YYYY");
                    });
                    data = res;
                    idPurchaseOrder = res[0]?.idPurchaseOrder;
                }
                this.setState({ firstPIList: data }, () => {
                    if (idPurchaseOrder > 0) {
                        this.USP_Transaction_PurchaseOrderSelectbyID_PendingQty(idPurchaseOrder);
                    }
                });
            }
        });
    }

    USP_Transaction_PurchaseOrderSelectbyID_PendingQty = (idPurchaseOrder) => {
        if (idPurchaseOrder > 0) {
            let request = [idPurchaseOrder, this.state.purchaseObject.idMaterialInward, this.state.purchaseObject.updateStatus];
            this.transactionStockServices.USP_Transaction_PurchaseOrderSelectbyID_PendingQty(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[1];
                    let data = [];
                    let idItem = 0;
                    if (res && res.length > 0) {
                        data = res;
                        idItem = res[0]?.idItem;
                    }
                    this.setState({ secondPIList: data }, () => {
                        // if (idItem > 0) {
                        //     this.getItemRateVendorwiseSelect3(idItem);
                        // }
                    });
                }
            });
        }
    }

    getItemRateVendorwiseSelect3 = (idItem) => {
        if (idItem > 0) {
            this.transactionStockServices.getItemRateVendorwiseSelect3(idItem).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent;
                    let data = [];
                    if (res.length > 0) {
                        data = res;
                    }
                    this.setState({ thirdPIList: data }, () => {
                    });
                }
            });
        }
    }

    addProduct = async () => {
        const selectedRows = this.state.selectedRowsForfirstPOList;
        const productMaterialTypeList = this.state.productObject.materialTypeList;
        let itemMap = new Map();

        for (const z of selectedRows) {
            const request = [
                z.idPurchaseOrder,
                this.state.purchaseObject.idMaterialInward,
                this.state.purchaseObject.updateStatus
            ];

            try {
                const response = await this.transactionStockServices.USP_Transaction_PurchaseOrderSelectbyID_PendingQty(request);

                if (response.statusCode === 200 && response.responseItem !== null) {
                    const res = response.responseItem.responseContent[1];

                    if (res.length > 0) {
                        for (const details of res) {
                            const key = `${details.idItem}_${details.itemDrawingNo}_${details.itemName}`;
                            const itemRate = details.rate || 0;
                            const qty = details.recvQty || 0;
                            const amt = details.amount || (itemRate * qty);
                            const taxableAmt = details.taxableAmt || 0;

                            const sgstAmt = details.sgstAmt || 0;
                            const cgstAmt = details.cgstAmt || 0;
                            const igstAmt = details.igstAmt || 0;

                            if (itemMap.has(key)) {
                                const existing = itemMap.get(key);
                                existing.quantity += qty;
                                existing.amount += amt;
                                existing.discountAmt += details.discountAmt || 0;
                                existing.chargesAmt += details.extraCharges || 0;
                                existing.total += taxableAmt;
                                existing.sgstAmount += sgstAmt;
                                existing.cgstAmount += cgstAmt;
                                existing.igstAmount += igstAmt;
                                existing.netTotal = (
                                    existing.total +
                                    existing.sgstAmount +
                                    existing.cgstAmount +
                                    existing.igstAmount
                                ).toFixed(2);
                            } else {
                                itemMap.set(key, {
                                    idPurchaseOrderItems: details.idPurchaseOrderItems,
                                    idPurchaseOrder: details.idPurchaseOrder,
                                    idMaterialPlanning: details.idMaterialPlanning || 0,
                                    idMaterialPlanningDetails: details.idMaterialPlanningDetails || 0,
                                    drawingNo: details.itemDrawingNo,
                                    materialType: details.itemItemType,
                                    idMaterialType: productMaterialTypeList.find(x => x.label === details.itemItemType)?.value,
                                    idItem: details.idItem,
                                    itemName: details.itemName,
                                    poQuantity: details.quantity,
                                    pendingQuantity: details.pendingQty,
                                    quantity: qty,
                                    poRate: itemRate,
                                    rate: itemRate,
                                    amount: amt,
                                    discount: details.discount || 0,
                                    discountAmt: details.discountAmt || 0,
                                    chargesAmt: details.extraCharges || 0,
                                    total: taxableAmt,
                                    idTaxGroup: details.idTaxGroup,
                                    sgst: details.sgst || 0,
                                    sgstAmount: sgstAmt,
                                    cgst: details.cgst || 0,
                                    cgstAmount: cgstAmt,
                                    igst: igstAmt > 0 ? details.igst : 0,
                                    igstAmount: igstAmt,
                                    netTotal: (taxableAmt + sgstAmt + cgstAmt + igstAmt).toFixed(2),
                                    poAmount: amt,
                                    poTaxableAmt: 0,
                                    remarks: details.itemRemarks,
                                });
                            }
                        }
                    }
                }
            } catch (error) {
                console.error("Error fetching pending PO items:", error);
            }
        }

        // Add existing state items (if needed)
        const oldItems = [...this.state.itemRowData];
        oldItems.forEach(item => {
            const key = `${item.idItem}_${item.drawingNo}_${item.itemName}`;
            if (!itemMap.has(key)) {
                itemMap.set(key, item);
            }
        });

        const finalItemList = Array.from(itemMap.values()).map((item, index) => ({
            ...item,
            keyId: index + 1
        }));

        this.setState({ itemRowData: finalItemList, open: false }, () => {
            this.finalCalculation();
        });
    };


    back = () => {
        this.setState({ open: false, selectedRowsForfirstPOList: [] });
    }

    handleOnClick = () => {
        this.setOpenModel2();
    }

    setOpenModel2 = () => {
        this.setState({ isSelectItemPopUp: !this.state.isSelectItemPopUp });
    };

    onFileChange = (event, identity) => {
        //debugger
        const file = event.target.files[0];
        // if (identity === "Upload_Certificate") {
        if (
            file &&
            (file.type === "image/jpeg" ||
                file.type === "image/png" ||
                file.type === "application/pdf" ||
                file.type === "application/pdf" ||
                file.type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                file.type ===
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                file.type === "application/msword" ||
                file.type === "application/msexcel" ||
                file.type === "application/vnd.ms-excel")
        ) {
            let uploadFile = { ...this.state.resFile };
            uploadFile.filename = file.name;
            uploadFile["file"] = file;
            uploadFile.storagePath = identity;
            let detail = { ...this.state.extraObject };
            detail.attachment = file.name;
            this.commonServices.uploadPDF(uploadFile).then((response) => {
                if (response != null) {
                    let detail = this.state.extraObject;
                    if (identity === 'attachment') {
                        detail.attachment = response.fileName;
                    }
                    this.setState({ extraObject: detail });
                    this.SwalServices.Success("Uploaded");
                }
                else {
                    this.SwalServices.Error(response.message);
                }
            })
        }
        else {
            this.SwalServices.Error("Please select only Image!");
        }
    };


    onSelectionChanged = (selectedRows) => {
        this.setState({ selectedRowsFromItemRows: selectedRows }, () => {
            if (selectedRows.length > 0) {
                this.finalCalculation();
            }
        });
    };

    render() {
        return (
            <>
                <div className='manual-invoice'>
                    <div className='data-display'>
                        <div className='data-display-inner relative'>
                            <ButtonGrp buttons={['add', 'print']}
                                onClickHandlers={{
                                    add: () => this.openPopUpForAddingItem(),
                                    // update: () => this.openPopUpForUpdateItem(),
                                    print: this.handlePrint,
                                }}
                            />
                            <MaterialTestingPopup
                                isModalOpen={this.state.isModalOpen}
                                setOpenModel={this.setOpenModel.bind(this)}
                                materialObject={this.state.materialObject}
                                extraObject={this.state.extraObject}
                                handleChange={this.handleChange.bind(this)}
                                handleChangeExtra={this.handleChangeExtra.bind(this)}
                                close={this.closePopup.bind(this)}
                                open={this.state.open}

                                addProduct={this.addProduct.bind(this)}
                                back={this.back.bind(this)}
                                submit={this.submit.bind(this)}
                                isSaving={this.state.isSaving}
                                validState={this.state.validState}
                                itemRowData={this.state.itemRowData}
                                itemColdefs={this.state.itemColdefs}


                                handleChangeForDropdown={this.handleChangeForDropdown.bind(this)}

                                onItemRowDataClicked={this.onItemRowDataClicked.bind(this)}
                                handleCellClickfirstPIList={this.handleCellClickfirstPIList.bind(this)}
                                handleCellClickSecondPIList={this.handleCellClickSecondPIList.bind(this)}
                                onSelectionChanged={this.onSelectionChanged.bind(this)}
                                handleOnClick={this.handleOnClick.bind(this)}
                                handleChangeForDropdownForExtraObject={this.handleChangeForDropdownForExtraObject.bind(this)}
                                insertItem={this.insertItem.bind(this)}
                                onFileChange={this.onFileChange.bind(this)}
                            />
                            <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                                <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 300px)" }}>
                                    <div className="table-inner">
                                        <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Material Testing</h1>
                                    </div>
                                    <AgGridReact
                                        rowData={this.state.rowData}
                                        rowHeight={this.state.rowHeight}
                                        columnDefs={this.state.colDefs}
                                        pagination={true}
                                        paginationPageSize={this.state.paginationPageSize}
                                        onRowDoubleClicked={this.onRowDoubleClicked}
                                        onGridReady={this.onGridReady}
                                        overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                        overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                        onCellClicked={this.handleCellClick}
                                    />
                                </div>
                            </div>

                            <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                                <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                    <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                        <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                    </div>
                                    <AgGridReact
                                        rowData={this.state.table2Data}
                                        columnDefs={this.state.table2ColDefs}
                                        rowHeight={this.state.rowHeight}
                                        pagination={true}
                                        paginationPageSize={this.state.paginationPageSize}
                                        onGridReady={this.onGridReady}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
